module.exports = __webpack_public_path__ + "img/矩形 41.9b46b019.png";